import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { of, ReplaySubject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { states } from '../../constants/states';

export interface State {
  name:string;
  code:string;
}

@Component({
  selector: 'app-state-select',
  templateUrl: './state-select.component.html',
  styleUrls: ['./state-select.component.scss']
})
export class StateSelectComponent implements OnInit {
  option = 'select';

  @Input()
  currentSelection: string;

  @Output()
  currentSelectionChange:EventEmitter<string> = new EventEmitter<string>();

  searching:boolean = false;
  filterCtrl = new FormControl();
  filteredOptions: ReplaySubject<State[]> = new ReplaySubject<State[]>(1);

  get current():State {
    if (!this.currentSelection) return null;
    return states.find(c => c.code.toLowerCase() == this.currentSelection.toLowerCase());
  }

  private _subscriptions: Subscription[] = [];

  constructor() { }

  ngOnInit(): void {

    this.filteredOptions.next(states);

    this._subscriptions.push(
      this.filterCtrl.valueChanges.pipe(
        debounceTime(250),
        distinctUntilChanged(),
        tap(()=> {
          this.searching = true;
        }),
        switchMap(val => {
          if (!val || val == '') {
            return of(states);
          }
          return of(states.filter(c=>c.name.toLowerCase().includes(val.toLowerCase())||c.code.toLowerCase().includes(val.toLowerCase())));
        }),
        tap(()=> {
          this.searching = false;
        })
      ).subscribe((options:State[]) => {
        this.filteredOptions.next(options);
      })
    );

  }

  ngOnDestroy() {
    this._subscriptions.forEach(s=>s.unsubscribe());
    this._subscriptions = [];
  }

  selectionMade(change:MatSelectChange) {
    this.filterCtrl.reset();
    this.currentSelection = change.value.code;
    this.currentSelectionChange.emit(change.value.code);
  }

  compareWith(s1: State, s2: State) {
    if (!s1 || !s2) {
      return s1 == s2;
    }
    return s1.code == s2.code;
  }

}
